import styled from 'styled-components';

export const ToolsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  align-items: flex-end;
`;
